
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";
import { UsersTable } from "./UsersTable";
import { SignupStats } from "./SignupStats";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";

interface UserRecord {
  id: string;
  email: string;
  created_at: string;
  last_sign_in_at: string;
  raw_user_meta_data: {
    avatar_url?: string;
    email?: string;
    full_name?: string;
    iss?: string;
    name?: string;
    picture?: string;
    provider_id?: string;
  };
}

interface SignupsSectionProps {
  users: UserRecord[];
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export const SignupsSection = ({ users, isOpen, onOpenChange }: SignupsSectionProps) => {
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-semibold">User Signups</h2>
      <SignupStats users={users} />
      
      <Collapsible
        open={isOpen}
        onOpenChange={onOpenChange}
        className="w-full"
      >
        <div className="flex items-center justify-between py-2">
          <CollapsibleTrigger asChild>
            <Button variant="ghost" className="flex items-center gap-2">
              <ChevronDown className={`h-4 w-4 transition-transform duration-200 ${isOpen ? 'transform rotate-180' : ''}`} />
              {isOpen ? 'Hide' : 'Show'} Signup History
            </Button>
          </CollapsibleTrigger>
        </div>
        <CollapsibleContent className="space-y-2">
          <UsersTable users={users} />
        </CollapsibleContent>
      </Collapsible>
    </div>
  );
};
